import { get, post } from '@/common/request';

const reviewSetMap = new Map([
  ['list', '/tenant/review/rule/pageList'],
  ['detail', '/tenant/review/rule/detail'],
  ['enable', '/tenant/review/rule/status'],
  ['add', '/tenant/review/rule/create'],
  ['delete', '/tenant/review/rule/delete'],
  ['update', '/tenant/review/rule/update'],
  ['execute', '/tenant/review/rule/execute'],
  ['selection', '/tenant/review/rule/selection'],
]);

/*
  列表用
*/
interface SearchParams {
  name?: string;
  categoryId?: string;
};

interface Permission {
  event: string;
  name: string;
}

export interface ReviewInfo {
  id: number;
  name: string, // 名称
  desc: string; // 场地类型
  category: string; // 场地类型
  enable: number; // 状态  0：未开启  1：已开启
  period?: string; // 执行周期
  interval?: number; // 时间间隔
  permissions: Permission[];
}

interface Response {
  pageNum?: number;
  pageSize?: number;
  totalNum?: number; // 总数量
  objectList?: ReviewInfo[];
}

/*
  详情用
*/
interface DetailCategory {
  id: number;
  name: string;
}

export interface DetailPlaceAttribute {
  categoryId: number;
  attributeId: number;
}

export interface DetailSpotAttribute {
  categoryId: number;
  attributeId: number;
}

interface DetailRole {
  id: number;
  name: string;
}

export interface ReviewDetail {
  id?: number;
  name?: string;
  desc?: string;
  category?: DetailCategory;
  enable?: number; // 开启状态  0：未开启  1：已开启
  period?: number; // 执行周期
  interval?: number; // 周期间隔
  placeAttributes?: DetailPlaceAttribute[];
  spotAttributes?: DetailSpotAttribute[];
  roles?: DetailRole[];
}

/*
  编辑用
*/
export interface ReviewEdit {
  id?: number;
  name?: string;
  desc?: string;
  categoryId?: number; // 场地类型id
  enable?: number; // 开启状态  0：未开启  1：已开启
  period?: number; // 执行周期
  interval?: number; // 周期间隔
  placeAttributes?: DetailPlaceAttribute[];
  spotAttributes?: DetailSpotAttribute[];
  roleIds: number[];
}

/*
  selection用
*/

interface SelectionItem {
  id: number;
  name: string;
}
export interface SelectionResp {
  encode: string; // 选项编码
  name: string; // 选项名称
  items: SelectionItem[]; // 选项值列表
}


export function getList(page: number, size: number, searchParams?: SearchParams): Promise<Response> {
  return get('/tenant/review/rule/pageList', { ...searchParams }, { proxyApi: '/resserv', needHint: true });
}

export function getDetail(id: number): Promise<ReviewDetail> {
  return get('/tenant/review/rule/detail', { id }, { proxyApi: '/resserv', needHint: true });
}

export function enable(id: number, status: 1 | 0) {
  return post('/tenant/review/rule/status', { id, status }, { proxyApi: '/resserv', needHint: true });
}

export function remove(id: number) {
  return post('/tenant/review/rule/delete', { id }, { proxyApi: '/resserv', needHint: true });
}

export function add(data: ReviewEdit) {
  return post('/tenant/review/rule/create', data, { proxyApi: '/resserv', needHint: true });
}

export function update(data: ReviewEdit) {
  return post('/tenant/review/rule/update', data, { proxyApi: '/resserv', needHint: true });
}

export function execute(id: number) {
  return post('/tenant/review/rule/execute', { id }, { proxyApi: '/resserv', needHint: true });
}

export function getSelection(): Promise<SelectionResp[]> {
  return get('/tenant/review/rule/selection', {}, { proxyApi: '/resserv', needHint: true });
}



export default reviewSetMap;
